export default {
  showShipping: false,

  /**
   * Design API
   */
  designApi: {
    url: 'https://cluster.mycs.com/api/designs/',
  },

  /**
   * Order API
   */
  orderApi: {
    url: 'https://cluster.mycs.com/api/orders/',
  },

  /**
   * User API
   */
  userApi: {
    url: 'https://cluster.mycs.com/api/users/',
  },
}



// WEBPACK FOOTER //
// ./src/config/config.production.js